import { IconProps } from 'components'
import { ComponentProps } from 'react'
import { theme } from 'styles/theme/hav-theme'

export const ND = ({
  color = theme.colors.neutral.light,
  fill = theme.colors.neutral.white,
  width = '26',
  height = '18',
  viewBox = '0 0 26 18',
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="0.5" y="0.5" width="25" height="17" rx="1.5" stroke={color} />
      <path
        d="M4.84 13.5V4.86H6.496L10.252 10.62V4.86H11.908V13.5H10.252L6.496 7.74V13.5H4.84ZM13.5822 13.5V4.86H16.3782C16.4462 4.86 16.5862 4.862 16.7982 4.866C17.0102 4.87 17.2142 4.884 17.4102 4.908C18.1062 4.992 18.6962 5.234 19.1802 5.634C19.6642 6.034 20.0322 6.542 20.2842 7.158C20.5362 7.774 20.6622 8.448 20.6622 9.18C20.6622 9.912 20.5362 10.586 20.2842 11.202C20.0322 11.818 19.6642 12.326 19.1802 12.726C18.6962 13.126 18.1062 13.368 17.4102 13.452C17.2142 13.476 17.0102 13.49 16.7982 13.494C16.5862 13.498 16.4462 13.5 16.3782 13.5H13.5822ZM15.2382 11.964H16.3782C16.4862 11.964 16.6322 11.962 16.8162 11.958C17.0002 11.95 17.1662 11.932 17.3142 11.904C17.6902 11.828 17.9962 11.652 18.2322 11.376C18.4722 11.1 18.6482 10.768 18.7602 10.38C18.8762 9.992 18.9342 9.592 18.9342 9.18C18.9342 8.748 18.8742 8.338 18.7542 7.95C18.6382 7.562 18.4602 7.234 18.2202 6.966C17.9802 6.698 17.6782 6.528 17.3142 6.456C17.1662 6.424 17.0002 6.406 16.8162 6.402C16.6322 6.398 16.4862 6.396 16.3782 6.396H15.2382V11.964Z"
        fill={color}
      />
    </svg>
  )
}
